import { render, staticRenderFns } from "./createResources.vue?vue&type=template&id=7b2fc0fb&scoped=true"
import script from "./createResources.vue?vue&type=script&lang=js"
export * from "./createResources.vue?vue&type=script&lang=js"
import style0 from "./createResources.vue?vue&type=style&index=0&id=7b2fc0fb&prod&scoped=true&lang=css"
import style1 from "./createResources.vue?vue&type=style&index=1&id=7b2fc0fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2fc0fb",
  null
  
)

export default component.exports